export const ALERT_REPORT_TIMESPAN_CHANGE_DETECTED = content => ({
    type: "ALERT_REPORT_TIMESPAN_CHANGE_DETECTED"
});
            
export const REPORT_TIIMESPAN_CHANGE_RESOLVED = content => ({
    type: "REPORT_TIIMESPAN_CHANGE_RESOLVED"
});
            
export const ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED = content => ({
    type: "ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED"
});
            
export const REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED = content => ({
    type: "REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED"
});
            
export const ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED = content => ({
    type: "ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED"
});
            
export const REPORT_ASSIGNED_TO_CHANGE_RESOLVED = content => ({
    type: "REPORT_ASSIGNED_TO_CHANGE_RESOLVED"
});

export const UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS = content => ({
    type: "UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS"
});

export const UPDATE_OVERDUE_TICKET_REPORT_OPEN_STATUS = content => ({
    type: "UPDATE_OVERDUE_TICKET_REPORT_OPEN_STATUS"
});

export const UPDATE_HOT_TICKET_REPORT_OPEN_STATUS = content => ({
    type: "UPDATE_HOT_TICKET_REPORT_OPEN_STATUS"
});

export const UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS = content => ({
    type: "UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS"
});

export const UPDATE_RESOLVED_BY_TECH_REPORT_OPEN_STATUS = content => ({
    type: "UPDATE_RESOLVED_BY_TECH_REPORT_OPEN_STATUS"
});

export const UPDATE_TIMESPAN_ASSIGNED_TO_ARRAY = content => ({
    type: "UPDATE_TIMESPAN_ASSIGNED_TO_ARRAY",
    payload: content
});

export const UPDATE_TIMESPAN_SORTING = content => ({
    type: "UPDATE_TIMESPAN_SORTING",
    payload: content
});

export const UPDATE_OVERDUE_SORTING = content => ({
    type: "UPDATE_OVERDUE_SORTING",
    payload: content
});

export const UPDATE_HOT_SORTING = content => ({
    type: "UPDATE_HOT_SORTING",
    payload: content
});

export const UPDATE_RESOLVED_SORTING = content => ({
    type: "UPDATE_RESOLVED_SORTING",
    payload: content
});

export const UPDATE_RESOLVED_BY_TECH_SORTING = content => ({
    type: "UPDATE_RESOLVED_BY_TECH_SORTING",
    payload: content
});

export const UPDATE_RESOLVED_TIMESPAN = content => ({
    type: "UPDATE_RESOLVED_TIMESPAN",
    payload: content
});

export const ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED = content => ({
    type: "ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED"
});

export const REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED = content => ({
    type: "REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED"
});

export const UPDATE_SURVEY_SORTING = content => ({
    type: "UPDATE_SURVEY_SORTING",
    payload: content
});

export const UPDATE_SURVEY_REPORT_OPEN_STATUS = content  => ({
    type: "UPDATE_SURVEY_REPORT_OPEN_STATUS"
});

export const UPDATE_SURVEY_AVERAGE_SORTING = content => ({
    type: "UPDATE_SURVEY_AVERAGE_SORTING",
    payload: content
});